var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176 96c0 44.18-35.82 80-80 80s-80-35.82-80-80 35.82-80 80-80 80 35.82 80 80z",
    style: {
      fill: "#f44336"
    },
    transform: "translate(-15.644 -15.645) scale(1.16297)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m118.624 62.064 11.312 11.312-56.56 56.56-11.312-11.312z",
    transform: "translate(-35.517 -35.518) scale(1.36997)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m129.936 118.624-11.312 11.312-56.56-56.56 11.312-11.312Z",
    transform: "translate(-35.517 -35.518) scale(1.36997)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCancelled);
export default __webpack_public_path__ + "static/media/status-cancelled.1a51a6e01f0a9997c8e2f527118be281.svg";
export { ForwardRef as ReactComponent };